import { render } from "./EventSection.vue?vue&type=template&id=1b279ed4"
import script from "./EventSection.vue?vue&type=script&lang=js"
export * from "./EventSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__